// ════════════════════════════════════════════════════════════════════════
// PAGE ADMIN — Points d'invitation aux comités (mai 2026)
// Migration S4.2 du plan TS+Vite (2026-05-10) : .js → .ts strict.
// ════════════════════════════════════════════════════════════════════════
//
// Paramétrage du nombre de points attribués par rôle dans le calcul
// "Qui doit participer au comité ?".
//
// 6 lignes figées (role_code immuables, label en lecture seule). Seul
// `points` est éditable. Permission : invitation_points.write.

interface InvitationPointRow {
  role_code: string;
  label: string;
  points: number;
  updated_at?: string | null;
}

pages.adminInvitationPoints = async function () {
  setHeader(t('invitation_points.page_title'), '');
  setContent(`<div class="loading">${esc(t('common.loading'))}</div>`);

  let rows: InvitationPointRow[];
  try {
    rows = (await api.getInvitationPoints()) as InvitationPointRow[];
  } catch (e: unknown) {
    const msg = e instanceof Error ? e.message : t('common.error');
    setContent(`<div class="error">${esc(msg)}</div>`);
    return;
  }

  const fmtModifiedAt = (iso: string | null | undefined): string =>
    iso ? t('invitation_points.modified_at', { date: fmtDateLocal(iso) }) : '';

  const html = `
    <div class="card">
      <p style="font-size:13px;color:var(--text2);margin-bottom:14px">${esc(t('invitation_points.intro'))}</p>
      <div class="table-wrap"><table>
        <thead><tr>
          <th style="width:40%">${esc(t('invitation_points.col.role'))}</th>
          <th style="width:120px">${esc(t('invitation_points.col.points'))}</th>
          <th></th>
        </tr></thead>
        <tbody>
          ${rows
            .map(
              (r) => `
            <tr data-role="${esc(r.role_code)}">
              <td>${esc(r.label)}
                <div style="font-size:10px;color:var(--text3);font-family:var(--font-mono)">${esc(r.role_code)}</div>
              </td>
              <td>
                <input type="number" class="ip-points" min="0" max="999" value="${r.points}"
                  data-role="${esc(r.role_code)}"
                  style="width:80px;font-size:13px;padding:4px 6px;border:1px solid var(--border2);border-radius:var(--radius);text-align:right">
              </td>
              <td style="font-size:11px;color:var(--text3)">
                <span class="ip-saved-${esc(r.role_code)}">${esc(fmtModifiedAt(r.updated_at))}</span>
              </td>
            </tr>
          `,
            )
            .join('')}
        </tbody>
      </table></div>
    </div>
  `;
  setContent(html);

  // Save automatique au blur sur l'input (UX simple, pas de bouton).
  document.querySelectorAll<HTMLInputElement>('.ip-points').forEach((inp) => {
    let lastSaved = inp.value;
    inp.addEventListener('change', () => {
      void (async () => {
        const role = inp.dataset['role'] || '';
        const val = parseInt(inp.value, 10);
        if (!Number.isFinite(val) || val < 0 || val > 999) {
          toast(t('invitation_points.error.range'), 'error');
          inp.value = lastSaved;
          return;
        }
        try {
          const updated = (await api.setInvitationPoint(role, val)) as InvitationPointRow;
          lastSaved = String(updated.points);
          inp.value = lastSaved;
          const saved = document.querySelector(`.ip-saved-${role}`);
          if (saved) saved.textContent = fmtModifiedAt(updated.updated_at);
          toast(t('invitation_points.toast.saved'));
        } catch (err: unknown) {
          const msg = err instanceof Error ? err.message : t('common.error');
          toast(msg, 'error');
          inp.value = lastSaved;
        }
      })();
    });
  });
};

export {};
